export default "__VITE_ASSET__Cc_Pm3LL__"